
<template>
    <div class="consumer">
      <div class="content">
          <distribution></distribution>
          <trend></trend>
        </div>
      </div>
  </div>


</template>

<script>
import axios from 'axios'
import trend from '../consumer/trend'
import distribution from '../consumer/distribution'

export default {
  components: {
    'trend': trend,
    'distribution': distribution
  }
}
</script>

<style scoped lang="scss">
.consumer {

  padding: 30px;
  background-color: #F8F9FB;

  .content >div:first-child {
    background-color: #fff;
  }

  .content {
    width: 1000px;
    margin: 0px auto;
  }
  .trend{
    margin-top: 50px;
    background-color: #fff;
  }
}



</style>



// WEBPACK FOOTER //
// src/views/index/data-analysis/consumer/consumer.vue